//src/services/customerHistoryApi.js

import { API_BASE_URL } from "../config/apiConfig";


export const getCustomerHistory = async (
  phone,
  network
) => {

  const response = await fetch(
    `${API_BASE_URL}/customer-history?phone=${phone}&network=${network}`
  );


  if (!response.ok) {
    throw new Error(
      "Failed to fetch customer history"
    );
  }


  return await response.json();
};